/* tslint:disable */
 
import { DataEntrySource } from './data-entry-source';
import { Icon } from './icon';
import { LocalizedValue } from './localized-value';
import { NullableLocalizedValue } from './nullable-localized-value';
import { StatisticQueryDtoRelatedData } from './statistic-query-dto-related-data';
import { StatisticQueryOptions } from './statistic-query-options';
import { StatisticQuerySourceOptions } from './statistic-query-source-options';
import { StatisticsQueryAggregation } from './statistics-query-aggregation';

/**
 * (tsType: Omit<StatisticQueryDTO, >, schemaOptions: { includeRelations: undefined, exclude: [] })
 */
export class StatisticQueryDto {
  aggregation: StatisticsQueryAggregation;
  chartType?: 0 | 1 | 2 | 3 | 4;
  dataEntity: string;
  description?: null | NullableLocalizedValue;
  filterField?: null | string;
  icon: null | Icon;
  id?: string;
  name: LocalizedValue;
  options?: null | StatisticQueryOptions;
  orderBy: 0 | 1;
  relatedData?: StatisticQueryDtoRelatedData;
  showAs: 0 | 1 | 2;
  showInEntityOverview: boolean;
  source: DataEntrySource;
  sourceOptions?: StatisticQuerySourceOptions;
  specificationVersion: number;
}
